/**
 * AI 스마트전단 HTML용 전용 하네스예요.
 * LLM이 만든 HTML은 data-role / data-barcode만 가지고 있고,
 * 클릭 동작(상세보기·장바구니)은 이 파일이 Vue 콜백으로 연결해요.
 */

const HANDLER_KEY = '__aiFlyerHarnessClickHandler';

/**
 * 클릭 대상에서 가장 가까운 data-role 요소를 찾는 함수예요.
 * 입력값: startEl(시작 DOM), role(찾을 data-role 값)
 * 반환값: 찾은 요소 또는 null
 */
function findRoleElement(startEl, role) {
  if (!startEl || typeof startEl.closest !== 'function') {
    return null;
  }
  return startEl.closest('[data-role="' + role + '"]');
}

/**
 * barcode로 상품 객체를 찾는 함수예요.
 * 입력값: productByBarcode(맵 객체), barcode(문자열)
 * 반환값: 상품 객체 또는 null
 */
function resolveProduct(productByBarcode, barcode) {
  if (!barcode || !productByBarcode) {
    return null;
  }
  return productByBarcode[barcode] || productByBarcode[String(barcode)] || null;
}

/**
 * AI 전단 루트에 클릭 위임을 붙이는 함수예요.
 * 입력값: options 객체
 *   - rootEl: AI HTML을 담은 DOM 요소
 *   - productByBarcode: barcode → 상품 객체 맵
 *   - onSelectProduct: 상품 상세 콜백(상품)
 *   - onAddCart: 장바구니 담기 콜백(상품)
 * 반환값: 없음
 */
function mountAiFlyerHarness(options) {
  const rootEl = options && options.rootEl;
  if (!rootEl) {
    return;
  }

  destroyAiFlyerHarness(rootEl);

  const productByBarcode = (options && options.productByBarcode) || {};
  const onSelectProduct = options && options.onSelectProduct;
  const onAddCart = options && options.onAddCart;

  /**
   * 클릭 이벤트를 처리하는 내부 함수예요.
   * 입력값: event(클릭 이벤트)
   * 반환값: 없음
   */
  const handleClick = function (event) {
    const target = event.target;
    if (!target) {
      return;
    }

    const addCartEl = findRoleElement(target, 'add-cart');
    if (addCartEl) {
      event.preventDefault();
      event.stopPropagation();
      const barcode = addCartEl.getAttribute('data-barcode');
      const product = resolveProduct(productByBarcode, barcode);
      if (!product) {
        return;
      }
      if (typeof onAddCart === 'function') {
        onAddCart(product);
      }
      return;
    }

    const productEl = findRoleElement(target, 'product');
    if (productEl) {
      event.preventDefault();
      const barcode = productEl.getAttribute('data-barcode');
      const product = resolveProduct(productByBarcode, barcode);
      if (!product) {
        return;
      }
      if (typeof onSelectProduct === 'function') {
        onSelectProduct(product);
      }
    }
  };

  rootEl[HANDLER_KEY] = handleClick;
  rootEl.addEventListener('click', handleClick);
}

/**
 * AI 전단 루트에서 클릭 위임을 떼는 함수예요.
 * 입력값: rootEl(DOM 요소)
 * 반환값: 없음
 */
function destroyAiFlyerHarness(rootEl) {
  if (!rootEl) {
    return;
  }
  const handler = rootEl[HANDLER_KEY];
  if (typeof handler === 'function') {
    rootEl.removeEventListener('click', handler);
  }
  try {
    delete rootEl[HANDLER_KEY];
  } catch (error) {
    rootEl[HANDLER_KEY] = undefined;
  }
}

export { mountAiFlyerHarness, destroyAiFlyerHarness, findRoleElement, resolveProduct };



// WEBPACK FOOTER //
// ./src/js/smartFlyerAiHarness.js